import { AxiosResponse } from 'axios';
import { csrfToken, getCsrfTokenOnCookie, instance } from '.';
import { EvaluationSendType } from '../../validation/evaluations/evaluationsType';

// 建材口コミの取得
export const getProductEvaluations = async (
  productId: number,
  limit: number,
  offset: number
): Promise<AxiosResponse> => {
  const response = await instance.get(
    `/products/${productId}/evaluations?limit=${limit}&offset=${offset}`,
    {
      headers: {
        'X-XSRF-TOKEN': csrfToken
      }
    }
  );
  return response;
};

// 評価更新API
export const updateEvaluation = async (
  evaluationId: number,
  score: number
): Promise<AxiosResponse> => {
  const response = await instance.put(
    `/evaluations/${evaluationId}`,
    {
      score: score
    },
    {
      headers: {
        'X-XSRF-TOKEN': csrfToken
      }
    }
  );
  return response;
};

// 口コミ送信API
export const sendReview = async (
  evaluationId: number,
  watch: (fieldName: string) => EvaluationSendType
): Promise<AxiosResponse> => {
  const csrftoken = await getCsrfTokenOnCookie();
  const response = await instance.put(
    `/evaluations/${evaluationId}/reviews`,
    {
      title: watch('title'),
      nickname: watch('nickname'),
      content: watch('content')
    },
    {
      headers: {
        'X-XSRF-TOKEN': csrftoken
      }
    }
  );
  return response;
};

//　評価削除API
export const deleteEvaluation = async (
  evaluationId: number
): Promise<AxiosResponse> => {
  const csrftoken = await getCsrfTokenOnCookie();
  const response = await instance.delete(`/evaluations/${evaluationId}`, {
    headers: {
      'X-XSRF-TOKEN': csrftoken
    }
  });
  return response;
};

// 事務局 口コミ送信API
export const adminSendReview = async (
  productId: number,
  watch: (fieldName: string) => EvaluationSendType,
  evaluationId?: number | null
): Promise<AxiosResponse> => {
  const csrftoken = await getCsrfTokenOnCookie();
  const url = evaluationId
    ? `/operator/evaluations/${evaluationId}/reviews`
    : '/operator/evaluations/reviews';
  const response = await instance.post(
    url,
    {
      product_id: productId,
      title: watch('title'),
      content: watch('content')
    },
    {
      headers: {
        'X-XSRF-TOKEN': csrftoken
      }
    }
  );
  return response;
};

// 事務局 建材口コミ取得
export const getAdminProductEvaluations = async (
  productId: number,
  limit: number,
  offset: number
): Promise<AxiosResponse> => {
  const response = await instance.get(
    `/operator/products/${productId}/evaluations?limit=${limit}&offset=${offset}`,
    {
      headers: {
        'X-XSRF-TOKEN': csrfToken
      }
    }
  );
  return response;
};

// 事務局 口コミ削除API
export const adminDeleteReview = async (
  evaluationId: number
): Promise<AxiosResponse> => {
  const response = await instance.delete(
    `/operator/evaluations/${evaluationId}`,
    {
      headers: {
        'X-XSRF-TOKEN': csrfToken
      }
    }
  );
  return response;
};
